import { render, staticRenderFns } from "./StepEconomy.vue?vue&type=template&id=808de7ee&"
import script from "./StepEconomy.vue?vue&type=script&lang=js&"
export * from "./StepEconomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports